package com.devi3east.bashbuddy.ktor.stripe.data.repositories

import com.devi3east.bashbuddy.account.organization.domain.models.StripeAccount
import com.devi3east.bashbuddy.ktor.stripe.data.api.StripeApi
import com.devi3east.bashbuddy.ktor.stripe.responses.DashboardLinkResponse
import com.devi3east.bashbuddy.ktor.stripe.domain.StripeRepository
import com.devi3east.bashbuddy.ktor.stripe.responses.StripeDashboardResponse

class StripeRepositoryImpl(
    private val api: StripeApi
) : StripeRepository {

    override suspend fun createConnectedAccount(token: String, email: String): Result<String> {
        return try {
            val response = api.createConnectedAccount(token, email)
            Result.success(response.accountId)
        } catch (e: Exception) {
            e.printStackTrace()
            Result.failure(e)
        }
    }

    override suspend fun createAccountOnboardingLink(token: String, accountId: String): Result<String> {
        return try {
            val response = api.createAccountOnboardingLink(token, accountId)
            Result.success(response.url)
        } catch (e: Exception) {
            e.printStackTrace()
            Result.failure(e)
        }
    }

    override suspend fun getDashboardLink(token: String): Result<DashboardLinkResponse> {
        return try {
            val response = api.getDashboardLink(token)
            Result.success(response)
        } catch (e: Exception) {
            e.printStackTrace()
            Result.failure(e)
        }
    }

    override suspend fun getStripeAccount(
        token: String
    ): Result<StripeAccount?> {
        return try {
            val account = api.getStripeAccount(token)
            Result.success(account)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    override suspend fun getStripeAccountWithDashboard(
        token: String
    ): Result<StripeDashboardResponse> {
        return runCatching {
            val account = getStripeAccount(token)
                .getOrElse { throw it }
                ?: throw Exception("No Stripe account found")

            val dashboardUrl = getDashboardLink(token)
                .getOrElse { throw it }
                .url

            StripeDashboardResponse(
                account = account,
                dashboardUrl = dashboardUrl
            )
        }
    }

}